import { TextField } from '@material-ui/core'
import { useEffect } from 'react'
import { useTranslate } from 'react-admin'

const DateTimeInput = ({
  record,
  label,
  required,
  source,
  setPayload,
  payload,
}) => {
  const translate = useTranslate()
  useEffect(() => {
    setPayload({ ...payload, [source]: record[source] })
  }, [])

  return (
    <TextField
      required={required}
      // error={required && errors.find((item) => item.id == props.id)}
      id="datetime-local"
      label={translate(label, { _: label })}
      type="datetime-local"
      value={payload[source]}
      style={{ width: '100%' }}
      InputLabelProps={{
        shrink: true,
        required: true,
      }}
      onChange={(e) => {
        // if (required && !e.target.value) {
        //   setErrors(() => {
        //     return errors.map((err) => {
        //       return err.id == props.id
        //         ? {
        //             id: props.id,
        //             source: source,
        //             type: type,
        //             label: label,
        //           }
        //         : err
        //     })
        //   })
        // } else {
        //   setErrors(() => {
        //     return errors.filter((item) => item.id !== props.id)
        //   })
        // }
        setPayload({ ...payload, [source]: e.target.value })
      }}
    />
  )
}
export default DateTimeInput
